export enum CreatureSortType
{
    PriceAsc,
    PriceDesc,
    LevelAsc,
    LevelDesc,
    HpAsc,
    HpDesc,
    RarityAsc,
    RarityDesc,
    TokenIdAsc,
    TokenIdDesc,
}